export default {
    ExternalPlatformProducts: {
        Channel: '渠道',
        Store: '店铺',
        ProductID: '平台商品ID',
        specificationID: '平台规格ID',
        ProductCode: '平台商品编码',
        specificationCode: '平台规格编码',
        status: '匹配状态',
        Method: '匹配方式',
        productstatus: '平台商品状态',
        inventory: '是否同步库存',
        Capture: '抓单回写标签',
        CaptureTip: '开启后,订单抓入 CSG Hub 后会在 Shopify 源订单上追加 csg-captured 标签。',
        Activity: '活动状态',
        type: '系统商品类型',
        creation: '平台创建时间',
        acquisition: '系统获取时间',
        download: '商品下载',
        byID: '按商品ID下载',
        bytime: '按时间段下载',
        Manual: '手动匹配',
        System: '系统匹配',
        Excel: 'Excel导入匹配',
        More: '更多',
        Listing: '上架',
        Off: '下架',
        Synchronize: '同步库存',
        Inventorylog: '库存同步日志',
        the: '平台商品ID（平台的系统商品ID，非手动填写编码，每行一个,换行输入或以英文逗号,分隔输入，最大允许输入100个）',
        form: {
            Channel: '渠道',
            Store: '店铺',
            image: '平台商品图片',
            Name: '平台商品名称',
            Code: '平台商品编码',
            Platformname: '平台规格名称',
            Platformcode: '平台规格编码',
            PlatformID: '平台商品ID',
            specificationID: '平台规格ID',
            status: '活动状态',
            Price: '价格',
            productstatus: '平台商品状态',
            Matching: '匹配状态',
            method: '匹配方式',
            System: '系统商品类型',
            product: '系统商品名称',
            ProductCode: '系统商品编码',
            Systemname: '系统SKU名称',
            SKU: '系统SKU编码',
            Inventory: '平台库存',
            occupied: '占用库存',
            Occupation: '占用方式',
            creation: '平台创建时间',
            acquisition: '系统获取时间',
        },
        Matching: '匹配商品',
        Product: '商品分类',
        Productbrand: '商品品牌',
        Productcode: '商品编码',
        Productname: '商品名称',
        SKUcode: 'SKU编码',
        SKUname: 'SKU名称',
        Sales: '销售价',
        Please: '请输入商品编码',
        enter: '请输入SKU编码',
        downloading: '手工下载商品',
        operation: '此操作涉及到SKU层级的更改, 是否继续?',
        Items: '匹配失败的商品无法同步',
        Log: '日志',
        confirm: {
            store: '选择店铺',
            Encoding: '编码',
            Name: '名称',
            Sales: '销售渠道',
            Type: '类型',
            status: '授权状态',
            enter: '请输入网店编码',
            Please: '请输入网店名称',
            select: '请选择渠道',
        }
    }
};
